type Stage = 'scoring' | 'report'

const STEPS: { key: Stage | 'received'; label: string }[] = [
  { key: 'received', label: 'Answers received' },
  { key: 'scoring', label: 'Scoring your answers' },
  { key: 'report', label: 'Building your report' },
]

/** Shown while results are being prepared: a spinning compass and the steps, so the candidate knows something is happening and nothing is needed from them. */
export default function ReportProgress({ stage, compact = false }: { stage: Stage; compact?: boolean }) {
  const active = STEPS.findIndex((s) => s.key === stage)
  return (
    <div className={`progress-card${compact ? ' compact' : ''}`} role="status" aria-live="polite">
      <div className="pc-compass" aria-hidden="true">
        <span className="pc-orbit pc-o1" /><span className="pc-orbit pc-o2" /><span className="pc-orbit pc-o3" />
        <svg viewBox="0 0 64 64" width="100%" height="100%">
          <defs>
            <linearGradient id="pc-ring" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#6366f1" /><stop offset=".55" stopColor="#a855f7" /><stop offset="1" stopColor="#22d3ee" /></linearGradient>
            <linearGradient id="pc-n" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#fff" /><stop offset="1" stopColor="#22d3ee" /></linearGradient>
          </defs>
          <circle cx="32" cy="32" r="26" className="pc-glow" />
          <circle cx="32" cy="32" r="22.5" fill="none" stroke="url(#pc-ring)" strokeWidth="3.2" />
          <circle cx="32" cy="32" r="17" className="pc-dash" />
          <g className="pc-needle"><path d="M32 12 38.5 32H25.5z" fill="url(#pc-n)" /><path d="M32 52 38.5 32H25.5z" fill="#8b5cf6" /></g>
          <circle cx="32" cy="32" r="4.2" fill="#0b1020" stroke="#fff" strokeWidth="2" />
        </svg>
      </div>
      <div className="pc-body">
        <h2>{stage === 'scoring' ? 'We are scoring your answers' : 'Your report is being prepared'}</h2>
        {!compact && <p className="muted">This usually takes about a minute. You can stay on this page: it updates by itself. There is nothing you need to do.</p>}
        <div className="pc-bar" aria-hidden="true"><span /></div>
        {!compact && (
          <ol className="pc-steps">
            {STEPS.map((s, i) => (
              <li key={s.key} className={i < active ? 'done' : i === active ? 'now' : 'next'}>
                <span className="pc-dot" aria-hidden="true">{i < active ? '✓' : ''}</span>
                {s.label}
                <span className="sr-only">{i < active ? ' (done)' : i === active ? ' (in progress)' : ' (waiting)'}</span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  )
}
